import React, { memo } from "react";
import NodeWrapper from "./NodeWrapper";
import { FilterAlt } from "@mui/icons-material";
import { Handle, Position } from "@xyflow/react";
import useHandleConnected from "./useHandleConnected";

/**
 * Filter Node — Filtrar items por condicao (passa ou bloqueia).
 *
 * data.filterField: string — campo a verificar
 * data.filterOperator: string — operador (equals, contains, isEmpty, etc)
 * data.filterValue: string — valor de comparacao
 *
 * Saidas: handle "pass" (item passa), handle "reject" (item bloqueado)
 */
const OPERATORS_LABEL = {
  equals: "==",
  notEquals: "!=",
  contains: "contem",
  notContains: "nao contem",
  startsWith: "inicia com",
  endsWith: "termina com",
  isEmpty: "vazio",
  isNotEmpty: "nao vazio",
  greaterThan: ">",
  lessThan: "<",
  regex: "regex",
};

const FilterNode = memo(({ id, data, isConnectable, selected }) => {
  const getHandleClass = useHandleConnected(id);
  const field = data?.filterField || "campo";
  const op = data?.filterOperator || "equals";
  const value = data?.filterValue || "";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<FilterAlt />}
      title="Filtro"
      color="#00695C"
      bgColor="#E0F2F1"
      noSource
      isConnectable={isConnectable}
      selected={selected}
      minWidth={210}
    >
      {/* Filter expression */}
      <div style={{
        background: "#fff",
        border: "1px solid #e0e0e0",
        borderRadius: 6,
        padding: "5px 10px",
        display: "flex",
        alignItems: "center",
        gap: 5,
        fontSize: 11,
        fontFamily: "'Fira Code', monospace",
        flexWrap: "wrap",
      }}>
        <span style={{ color: "#00695C", fontWeight: 600 }}>{field}</span>
        <span style={{
          color: "#fff",
          background: "#555",
          borderRadius: 3,
          padding: "0 5px",
          fontSize: 9,
          fontWeight: 700,
        }}>
          {OPERATORS_LABEL[op] || op}
        </span>
        {op !== "isEmpty" && op !== "isNotEmpty" && (
          <span style={{ color: "#C62828", fontWeight: 600 }}>
            {value || "?"}
          </span>
        )}
      </div>

      {/* Pass / Reject handles */}
      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 8 }}>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "flex-end",
          gap: 6, position: "relative", paddingRight: 4,
        }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#4caf50", borderRadius: 4,
            padding: "2px 10px",
          }}>
            PASSA
          </span>
          <Handle
            type="source"
            position={Position.Right}
            id="pass"
            className={getHandleClass("source", "pass")}
            style={{
              position: "absolute", top: "50%", right: -13,
              transform: "translateY(-50%)",
              cursor: "crosshair",
            }}
            isConnectable={isConnectable}
          />
        </div>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "flex-end",
          gap: 6, position: "relative", paddingRight: 4,
        }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#ef5350", borderRadius: 4,
            padding: "2px 10px",
          }}>
            REJEITA
          </span>
          <Handle
            type="source"
            position={Position.Right}
            id="reject"
            className={getHandleClass("source", "reject")}
            style={{
              position: "absolute", top: "50%", right: -13,
              transform: "translateY(-50%)",
              cursor: "crosshair",
            }}
            isConnectable={isConnectable}
          />
        </div>
      </div>
    </NodeWrapper>
  );
});

FilterNode.displayName = "FilterNode";
export default FilterNode;
